import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MiscellaneousComponent } from './miscellaneous.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { NotFoundComponent } from './not-found/not-found.component';

const routes: Routes = [
	{
		path: '',
		component: MiscellaneousComponent,
		children: [
			{ path: 'notauthorized', component: NotAuthorizedComponent },
			{ path: '404', component: NotFoundComponent },
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class MiscellaneousRoutingModule {}

export const routedComponents = [MiscellaneousComponent, NotFoundComponent, NotAuthorizedComponent];
